import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";
import { RecentlyOpenedItemConfigurationProps, useResolveRecentlyOpenedItemForPersistence } from "./useResolveRecentlyOpenedItemForPersistence";
import { useAnalyticsStore } from "client/Features/Analytics/analyticsStore";
import { useRecentlyOpenedResults } from "client/Features/Search/RecentSearch/Persistence/useRecentlyOpenedResults";
import { AnalyticsAppEventData } from "client/Api/Analytics/analytics";
import { AppType } from "client/Api/Apps/common";
import { useCallback } from "react";
import { getHubUrlForEvent } from "client/Features/Hub/Events/EventsPage";
import { HubDataSource } from "client/Api/Hub/hub";
import { navigateTo } from "client_legacy/ndaw/navigator";

export type EventNavigationHandlerProps = {
	id: number;
}
	& RecentlyOpenedItemConfigurationProps;

export function useEventNavigationHandler(props: EventNavigationHandlerProps): (() => void) {
	const {
		id
	} = props;

	const addAnalyticsAppEvent: (data: AnalyticsAppEventData) => void = useAnalyticsStore(x => x.addAppEvent);
	const { registerFromRecentlyOpened: registerRecentlyOpenedItem } = useRecentlyOpenedResults();

	const recentlyOpenedItem: GlobalSearchItemPersistedModel = useResolveRecentlyOpenedItemForPersistence(props);

	return useCallback(
		(): void => {
			addAnalyticsAppEvent({ appType: AppType.Hub });
			registerRecentlyOpenedItem(recentlyOpenedItem);
			navigateToEvent(id);
		},
		[
			addAnalyticsAppEvent,
			id,
			recentlyOpenedItem,
			registerRecentlyOpenedItem
		]
	);
}

export function navigateToEvent(id: number): void {
	const url: string = getHubUrlForEvent({
		source: HubDataSource.Event,
		itemId: id
	});

	navigateTo(url);
}